import React from "react";
import Navbar from "../nav/Navbar";

const Header = () => {
  return (
    <header>
     <Navbar/>
    </header>
  );
};

export default Header;
